
// Static registry of all bind fields in configData.
// fieldPath: "module.field" — used for conflict detection across the whole app.
export const BIND_REGISTRY = [
    // Crosshair
    { fieldPath: 'crosshair.bind_toggle_presets', label: 'Toggle Mira (Presets)' },

    // Binds — Movement
    { fieldPath: 'binds.key_forward',   label: 'Avanzar' },
    { fieldPath: 'binds.key_back',      label: 'Retroceder' },
    { fieldPath: 'binds.key_left',      label: 'Izquierda' },
    { fieldPath: 'binds.key_right',     label: 'Derecha' },
    { fieldPath: 'binds.key_walk',      label: 'Caminar' },
    { fieldPath: 'binds.key_duck',      label: 'Agacharse' },
    { fieldPath: 'binds.key_jump',      label: 'Saltar' },

    // Binds — Weapons & Combat
    { fieldPath: 'binds.key_attack',    label: 'Disparar' },
    { fieldPath: 'binds.key_attack2',   label: 'Click Derecho' },
    { fieldPath: 'binds.key_reload',    label: 'Recargar' },
    { fieldPath: 'binds.key_use',       label: 'Usar / Plantar' },
    { fieldPath: 'binds.key_drop',      label: 'Soltar Arma' },
    { fieldPath: 'binds.key_inspect',   label: 'Inspeccionar' },
    { fieldPath: 'binds.key_lastinv',   label: 'Última Arma' },
    { fieldPath: 'binds.key_buymenu',   label: 'Menú Compra' },
    { fieldPath: 'binds.key_autobuy',   label: 'Auto Compra' },
    { fieldPath: 'binds.key_rebuy',     label: 'Re-Compra' },

    // Binds — Weapon Slots
    { fieldPath: 'binds.key_slot1',     label: 'Slot 1 — Rifle' },
    { fieldPath: 'binds.key_slot2',     label: 'Slot 2 — Pistola' },
    { fieldPath: 'binds.key_slot3',     label: 'Slot 3 — Cuchillo' },
    { fieldPath: 'binds.key_slot4',     label: 'Slot 4 — Granada' },
    { fieldPath: 'binds.key_slot5',     label: 'Slot 5 — Bomba' },

    // Binds — Grenades
    { fieldPath: 'binds.grenade_flash',   label: 'Flash' },
    { fieldPath: 'binds.grenade_smoke',   label: 'Smoke' },
    { fieldPath: 'binds.grenade_molotov', label: 'Molotov / Incendiaria' },
    { fieldPath: 'binds.grenade_he',      label: 'HE Granada' },
    { fieldPath: 'binds.grenade_decoy',   label: 'Señuelo' },
    { fieldPath: 'binds.key_taser',       label: 'Zeus' },
    { fieldPath: 'binds.key_healthshot',  label: 'Healthshot' },

    // Binds — Communication
    { fieldPath: 'binds.key_mic',          label: 'Micrófono' },
    { fieldPath: 'binds.key_chat',         label: 'Chat General' },
    { fieldPath: 'binds.key_chat_team',    label: 'Chat Equipo' },
    { fieldPath: 'binds.key_ping',         label: 'Ping' },
    { fieldPath: 'binds.key_radio1',       label: 'Radio 1' },
    { fieldPath: 'binds.key_radio2',       label: 'Radio 2' },
    { fieldPath: 'binds.key_radio3',       label: 'Radio 3' },
    { fieldPath: 'binds.key_radial_radio',  label: 'Radio Radial' },
    { fieldPath: 'binds.key_radial_radio2', label: 'Radio Radial 2' },

    // Binds — UI & Misc
    { fieldPath: 'binds.key_score',         label: 'Marcador' },
    { fieldPath: 'binds.key_console',       label: 'Consola' },
    { fieldPath: 'binds.key_spray',         label: 'Spray' },
    { fieldPath: 'binds.key_team_equip',    label: 'Equipar Equipo' },
    { fieldPath: 'binds.key_show_loadout',  label: 'Ver Equipamiento' },
    { fieldPath: 'binds.key_team_menu',     label: 'Menú Equipo' },
    { fieldPath: 'binds.key_screenshot',    label: 'Captura de Pantalla' },
    { fieldPath: 'binds.key_quit_prompt',   label: 'Salir del Juego' },
    { fieldPath: 'binds.key_sell_back_all', label: 'Vender Todo' },
    { fieldPath: 'binds.key_inv_next',      label: 'Inventario Siguiente' },
    { fieldPath: 'binds.key_inv_prev',      label: 'Inventario Anterior' },
    { fieldPath: 'binds.key_cancel_select', label: 'Cancelar Selección' },

    // Binds — Especiales
    { fieldPath: 'binds.jump_throw_key',           label: 'Jump Throw' },
    { fieldPath: 'binds.bind_mute_all',            label: 'Mutear Todos' },
    { fieldPath: 'binds.bind_vol_up',              label: 'Subir Volumen' },
    { fieldPath: 'binds.bind_vol_down',            label: 'Bajar Volumen' },
    { fieldPath: 'binds.bind_voice_up',            label: 'Subir Voz' },
    { fieldPath: 'binds.bind_voice_down',          label: 'Bajar Voz' },
    { fieldPath: 'binds.bind_radar_toggle',        label: 'Toggle Radar' },
    { fieldPath: 'binds.viewmodel_switchhands_bind', label: 'Cambiar Mano' },
    { fieldPath: 'binds.radar_big_key',            label: 'Radar Grande' },
    { fieldPath: 'binds.radar_overview_key',       label: 'Radar Mapa Completo' },

    // Practice
    { fieldPath: 'practice.bind_noclip',         label: 'Noclip' },
    { fieldPath: 'practice.bind_rethrow',         label: 'Relanzar Granada' },
    { fieldPath: 'practice.bind_bot_place',       label: 'Colocar Bot' },
    { fieldPath: 'practice.bind_bot_add_t',       label: 'Añadir Bot T' },
    { fieldPath: 'practice.bind_bot_add_ct',      label: 'Añadir Bot CT' },
    { fieldPath: 'practice.bind_bot_kick',        label: 'Kickear Bots' },
    { fieldPath: 'practice.bind_timescale',       label: 'Velocidad Tiempo' },
    { fieldPath: 'practice.bind_restart_round',   label: 'Reiniciar Ronda' },
    { fieldPath: 'practice.bind_save_pos',        label: 'Guardar Posición' },
    { fieldPath: 'practice.bind_load_pos',        label: 'Cargar Posición' },
    { fieldPath: 'practice.bind_clear_util',      label: 'Limpiar Utilidades' },
    { fieldPath: 'practice.bind_toggle_impacts',  label: 'Toggle Impactos' },
    { fieldPath: 'practice.bind_prac_alias',      label: 'Alias de Práctica' },
]

/**
 * Returns a Map<key, { label, fieldPath }> of all currently assigned binds,
 * optionally excluding selfFieldPath (the field being edited).
 */
export function getAllAssignedBinds(configData, excludeFieldPath = null) {
    const result = new Map()

    for (const { fieldPath, label } of BIND_REGISTRY) {
        if (fieldPath === excludeFieldPath) continue
        const [module, field] = fieldPath.split('.')
        const val = configData?.[module]?.[field]
        if (val && typeof val === 'string') {
            if (!result.has(val)) {
                result.set(val, { label, fieldPath })
            }
        }
    }

    // Dynamic: custom_binds array
    const customBinds = configData?.binds?.custom_binds || []
    customBinds.forEach((bind, i) => {
        const fp = `binds.custom_binds.${i}.key`
        if (fp === excludeFieldPath) return
        if (bind.key && typeof bind.key === 'string') {
            if (!result.has(bind.key)) {
                result.set(bind.key, { label: `Compra rápida: ${bind.name}`, fieldPath: fp })
            }
        }
    })

    return result
}

/**
 * Returns conflict info { label, fieldPath } if newKey is already assigned
 * somewhere other than selfFieldPath, or null if no conflict.
 */
export function findConflict(configData, newKey, selfFieldPath) {
    if (!newKey) return null
    const all = getAllAssignedBinds(configData, selfFieldPath)
    return all.get(newKey) || null
}
